module.exports = __webpack_public_path__ + "static/media/Thank You-1.7509f419.jpg";